// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_RevenueConciliationUnlinkRecebimentoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_RevenueConciliationUnlinkRecebimentoResponseDados {
deleted_count: number
remaining_linked_count: number
}

export type Payroll_RevenueConciliationUnlinkRecebimentoResponse = ApiResponse<Payroll_RevenueConciliationUnlinkRecebimentoResponseDados>;

registerResponseContract('Payroll_RevenueConciliationUnlinkRecebimentoResponse', {
  deleted_count:          { type: 'number',  required: true },
  remaining_linked_count: { type: 'number',  required: true },
})
